import React from 'react';

const AppointmentExpired = ({ doctorName, expiredText }) => {
    return (
        <div className="container d-flex align-items-center flex-column elements-spacing fw-bold text-center">
            {/*<div>מועד תור זה עבר ולא ניתן לאשר כעת את ההגעה.</div>*/}
            {/*<div>יש לפנות למרפאה</div>*/}
            {expiredText()}
            <div className="seperator">
                תודה, {doctorName}
            </div>
        </div>
    );
}

export default AppointmentExpired;